import { sendRequest } from 'api/sendRequest';
import { OneOnOneInsightsRequestI } from 'screens/oneOnOneRabbit/Insights/interfaces';

import { endpoints } from 'constants/endpoints';

export const getOneOnOneInsightsTabularDataApi = ({
  isExpandedViewRequired,
  cohort,
  dateRange,
  groupByKeys,
  orderBy,
}: OneOnOneInsightsRequestI) => {
  const url = endpoints.oneOnOneRevamped.insights.tabular;
  const timestampDateRange = {
    startTS: dateRange.startDate.getTime(),
    endTS: dateRange.endDate.getTime(),
  };
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      isExpandedViewRequired,
    },
    body: {
      cohortId: cohort.id,
      dateRange: timestampDateRange,
      groupByKeys,
      orderBy,
    },
  });
};
